import {twMerge} from 'tailwind-merge';

export default function Error404({...props}) {
	return (
		<div className={twMerge([
			'flex justify-center flex-col items-center h-screen w-screen',
			props?.className
		])}>
			<h1 className="text-7xl font-bold">4<span className="text-slate-300">0</span>4</h1>
			<p className="text-slate-500 text-lg mt-5">This page could not be found!</p>
		</div>
	);
}
